import { FocusDto } from '../coaching-base/general';
import { CommitmentGoalMetric } from '../coaching-base/general/commitment-goal-metric.model';

import { focusesMatch } from './focuses-match.function';

// TODO maybe only apply this validator when the commitment is attempting to leave draft status
// TODO same check needs to be added to the api
/** ensures that the focus is not already set on an active commitment */
export function isActiveFocus(
    focus: FocusDto,
    activeCommitmentFocuses: CommitmentGoalMetric[],
    commitmentId: number,
): boolean {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const found =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        activeCommitmentFocuses &&
        activeCommitmentFocuses.find((e) => focusesMatch(e, focus));
    return found != null && found.commitmentId !== commitmentId;
}
